import { render, staticRenderFns } from "./ReportEdit.vue?vue&type=template&id=126c5116&scoped=true&"
import script from "./ReportEdit.vue?vue&type=script&lang=ts&"
export * from "./ReportEdit.vue?vue&type=script&lang=ts&"
import style0 from "./Report.scss?vue&type=style&index=0&id=126c5116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126c5116",
  null
  
)

export default component.exports